import { useContext, useState } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomCard,
  CustomIcon,
  CustomLeafLetArea,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";
import "./index.scss";
import { ICreateAndUpdateCategory } from "../../../../types/category.interface";
import { WEEK_DAY } from "../../../../values/dropdownItems";
import utils from "../../../../utils";
import { useQuery } from "react-query";
import values from "../../../../values";
import api from "../../../../api";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import {
  ICreateAndUpdateArea,
  ILatLng,
} from "../../../../types/area.interface";
import DescriptionArea from "./DescriptionArea";
import { useTranslation } from "react-i18next";

const Body = (data: any) => {
  const { resultArea, setSelectedArea, setShowModal, showModal, selectedArea } =
    useContext(Context.AreaScreen);

  const [defaultLatLngArea, setDefaultLatLngArea] = useState<ILatLng>({
    lat: 36.92448,
    lng: 50.641372,
  });

  const coords = resultArea?.data?.result?.docs?.map((item: any) => {
    return { _id: item?._id, coords: item?.coords, title: item?.name };
  });

  const onEdit = (area: ICreateAndUpdateArea) => {
    setSelectedArea!(area);
    setShowModal!("UPDATE");
  };
  const onRemove = (area: ICreateAndUpdateArea) => {
    setSelectedArea!(area);
    setShowModal!("DELETE");
  };
  const onClickEvent = (area: ICreateAndUpdateArea) => {
    setSelectedArea!(area);
    setShowModal!("DETAIL");
  };

  const onClickHandler = (lanLng: [number, number]) => {
    console.log(lanLng);
    setDefaultLatLngArea({ lat: lanLng[0], lng: lanLng[1] });
  };

  const { t } = useTranslation();

  // const workTimesWithCompleteTitle = utils.workTimeWithCompeleteTitle(areas);

  return (
    <Row className="row-align-start relative" id="area-body-list">
      {showModal === "DETAIL" && (
        <DescriptionArea
          onEdit={onEdit}
          onRemove={onRemove}
          selectedArea={selectedArea}
        />
      )}
      <Column medium={12}>
        <CustomLeafLetArea
          items={coords}
          onEdit={onEdit}
          onRemove={onRemove}
          onClickEvent={onClickEvent}
          defaultLatLngArea={defaultLatLngArea}
        />
      </Column>
      <Column medium={3} className="area-sidebar">
        <div className="all-area-title">{t("all-area")} </div>
        {coords?.length === 0 ? (
          <CustomBadges title={t("no-area")} type="warning" />
        ) : (
          <ul>
            {coords?.map((item: any) => (
              <li onClick={() => onClickHandler(item?.coords?.[0])}>
                <DescriptionArea
                  onEdit={onEdit}
                  onRemove={onRemove}
                  selectedArea={item}
                />
              </li>
            ))}
          </ul>
        )}
      </Column>
    </Row>
  );
};

export default Body;
